import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const packingItemsApi = baseApi.injectEndpoints({
  reducerPath: "packingItemsApi",
  endpoints: (builder) => ({
    addPackingItems: builder.mutation({
      query: (user) => {
        return {
          url: "packing-list-item",
          method: "POST",
          body: user,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packinglistitem"],
    }),
    updatePackingItems: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `packing-list-item/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packinglistitem"],
    }),
    deletePackingItems: builder.mutation({
      query: (id) => {
        return {
          url: `packing-list-item/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packinglistitem"],
    }),
    getAllPackingItems: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `packing-list-item?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["packinglistitem"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddPackingItemsMutation,
  useUpdatePackingItemsMutation,
  useDeletePackingItemsMutation,
  useGetAllPackingItemsQuery, // Add this line to import the query hook
} = packingItemsApi;
